import axios from "axios";

export const getOutlierResults = async (email, filters, is_live = false, token) => {

	try {
		let queryRows = filters;
		
		// Normalize filters to ensure they have proper default values
		for (const row of queryRows) {
			// Set marketDepth default
			if (!row.marketDepth) {
				row.marketDepth = 3;
			}

			// Set isOver default
			if (row.isOver === undefined) {
				row.isOver = true;
			}

			// Normalize minMaxOdds - handle null, undefined, empty string, or missing values
			if (!row.minMaxOdds || !Array.isArray(row.minMaxOdds)) {
				row.minMaxOdds = [-9999999, 9999999];
			} else {
				if (row.minMaxOdds[0] === '' || row.minMaxOdds[0] === null || row.minMaxOdds[0] === undefined) {
					row.minMaxOdds[0] = -9999999;
				}
				if (row.minMaxOdds[1] === '' || row.minMaxOdds[1] === null || row.minMaxOdds[1] === undefined) {
					row.minMaxOdds[1] = 9999999;
				}
				// Convert to numbers
				row.minMaxOdds = [Number(row.minMaxOdds[0]), Number(row.minMaxOdds[1])];
			}

			// Normalize minMaxEv - handle null, undefined, empty string, or missing values
			if (!row.minMaxEv || !Array.isArray(row.minMaxEv)) {
				row.minMaxEv = [-9999999, 9999999];
			} else {
				if (row.minMaxEv[0] === '' || row.minMaxEv[0] === null || row.minMaxEv[0] === undefined) {
					row.minMaxEv[0] = -9999999;
				}
				if (row.minMaxEv[1] === '' || row.minMaxEv[1] === null || row.minMaxEv[1] === undefined) {
					row.minMaxEv[1] = 9999999;
				}
				// Convert to numbers
				row.minMaxEv = [Number(row.minMaxEv[0]), Number(row.minMaxEv[1])];
			}

			// Ensure dateDifference is set - calculate from date if missing
			if (row.dateDifference === undefined || row.dateDifference === null) {
				if (row.date) {
					const currentTime = Date.now();
					const fourHoursMs = 4 * 60 * 60 * 1000;
					const dateTime = new Date(row.date).getTime();
					const diffTime = dateTime - (currentTime - fourHoursMs);
					row.dateDifference = Math.floor(diffTime / (1000 * 60 * 60 * 24));
				} else {
					// Default to 7 days if no date
					row.dateDifference = 7;
				}
			}
		}

		const outlierResults = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/outlier_results?email=${email}&is_live=${is_live}&queryRows=${JSON.stringify(queryRows)}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return outlierResults.data;
	} catch (e) {
		console.error('ev screen e: ', e);
		return false;
	}
};
